import { cn } from '@v2/shared/lib/utils';

export type DocumentHtmlProps = {
  /**
   * The document, as markup.
   *
   * It is never a request value or a database row: it is a file in this repository,
   * rendered server-side and handed straight here, which is the same trust level as this
   * component's own JSX.
   */
  html: string;
  className?: string;
};

/**
 * A document written as HTML rather than as components — the privacy policy and the
 * terms of use, whose markup comes from `includes/modules/legal/`.
 *
 * Those two are chosen at request time: `privacyVersion` and `tosVersion` are per-site
 * options an administrator edits, each picking one of a set of dated documents, and the
 * version that resolves is recorded against every order as the agreement that customer
 * accepted. So the markup arrives as a string and gets its reading treatment from the
 * `prose` region it is dropped into, exactly like the pages that author their own copy —
 * including `ol[type='a']`, which is how the terms letter their sub-clauses.
 *
 * The one rule here is structural: this wrapper stands between the card's padding and
 * the document's first and last blocks, so it has to pass the card's margin reset
 * through or the padding is doubled at each end.
 */
export default function DocumentHtml({ html, className }: DocumentHtmlProps) {
  return (
    <div
      className={cn('[&>*:first-child]:mt-0 [&>*:last-child]:mb-0', className)}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
